import { useEffect, useRef, useState } from 'react';

// Local search text updates at once. The URL update waits for the debounce.
export function useSearchDraft(
  urlValue: string,
  commit: (value: string) => void,
  delayMs = 300,
): [string, (value: string) => void] {
  const [draft, setDraft] = useState(urlValue);
  const commitRef = useRef(commit);
  commitRef.current = commit;

  useEffect(() => {
    setDraft(urlValue);
  }, [urlValue]);

  useEffect(() => {
    if (draft === urlValue) return undefined;
    const handle = setTimeout(() => commitRef.current(draft), delayMs);
    return () => clearTimeout(handle);
  }, [delayMs, draft, urlValue]);

  return [draft, setDraft];
}
